export const tw = {
  'already_logout': '已登出，請再次登入',
  'logout': '登出',
  'user_login': '登入學習系統',
  'username': '帳號',
  'password': '密碼',
  'edit_password': '修改密碼',
  'login': '登入帳號',
  'hide_video': '收合影片',
  'view_video': '展開影片',
  'slow_audio_playback': '慢速音檔播放中',
  'video_transcript': '課程文章',
  'conversation_mission': '對話任務',
  'wordBank': '課程單字',
  'highlights': '課程重點',
  'slow_playback': '慢速',
  'view_translation': '翻譯',
  'dictionary': '字典',
  'fill_in_the_blanks': '聽力填空',
  'multiple_choice': '聽力理解',
  'complete_the_sentence': '翻譯填空',
  'unscramble_the_sentences': '句子重組',
  'the_assessment_begin_description': '您即將開始進行能力檢測。本能力檢測依照：聽力、字彙片語、文法句型、閱讀分為四個部分，每個部分約為12-16題，題目的難易度會依照答題的正確率而調整。',
  'start_test': '開始測驗',
  'next': '下一題',
  'assessment_completed_description': '恭喜您已經完成能力檢測！',
  'recommendation_according_assessment_result': '本系統將依據您的檢測結果，提供您推薦課程。您可以點選看分析查看剛才的考試結果，或是點選推薦課程，開始觀看線上課程。',
  'view_result': '看分析',
  'my_recommendation': '推薦課程',
  'view_assessment_history': '檢視過去能力紀錄',
  'assessment': '開始能力檢測',
  'view_recommendation': '前往推薦課程',
  'assessment_history': '歷史紀錄',
  'view_list': '顯示清單',
  'detail': '查看',
  'assessment_test': '能力檢測',
  'listening_skill': '聽力能力',
  'reading_skill': '閱讀能力',
  'vocabulary_skill': '單字能力',
  'grammar_skill': '文法能力',
  'test_date': '測驗日期',
  'period': '考試日期',
  'title': '考試名稱',
  'assigned_by': '指派老師',
  'listening': '聽力',
  'reading': '閱讀',
  'total': '總分',
  'status': '通過',
  'take_test': '功能',
  'n_a': '無',
  'not_released': '未開放',
  'test_is_over': '已結束',
  'go_test': '考試',
  'completed': '已完成',
  'no_test_found': '目前無考試資料',
  'my_test': '考試作業',
  'new_test': '新增考試',
  'added_on': '建立日期',
  'assignment_history': '指派清單',
  'assign': '指派',
  'edit': '編輯',
  'view_score': '檢視成績',
  'view': '檢視',
  'delete': '刪除',
  'assignment_deleting_notice': '考試指派中，若刪除清單，紀錄會一併刪除。',
  'deleting_confirm': '確定要刪除？',
  'warming_remind': '注意！此動作無法回覆。',
  'yes': '確認',
  'cancel': '取消',
  'deleted': '刪除成功',
  'class_deleted': '班級已刪除成功',
  'has_been_assigned_to': '已經指派給',
  'no_assignment_has_been_made': '目前無指派資訊',
  'deleting_assignment_confirm': '確定要刪除指派？',
  'assign_to': '您要指派 [{msg}] 給',
  'no_class_is_assigned': '目前無班級資訊',
  'submit_assign': '確認指派',
  'set_duration_of': '設定 [{msg}] 的指派時間',
  'class': '班級',
  'from': '開始時間',
  'to': '結束時間',
  'test_result_of': '檢視 [{msg}] 的指派班級成績',
  'more': '詳細內容',
  'please_check_time_format': '請檢查時間格式有無正確',
  'please_enter_valid_datetime': '指派時間錯誤',
  'replace': '更新考試',
  'add_test': '建立考試',
  'select': '選擇試卷',
  'test': '試卷名稱',
  'level': '級別',
  'time_used': '使用次數',
  'preview': '預覽試卷',
  // 'download': '預覽',
  'please_name_this_test': '考試名稱不得為空白',
  'please_choose_a_test': '需選擇試卷',
  'finish': '交卷',
  'test_completed': '完成考試',
  'class_name': '班級名稱',
  'teacher': '指導老師',
  'list_of_students': '學生名單',
  'edit_list': '編輯名單',
  'edit_class': '編輯班級',
  'add_class': '新增班級',
  'import_class_information': '匯入班級',
  'export_all_classes': '匯出全部班級',
  'download_list_of_class': '下載班級清單',
  'list_of_class': '班級清單',
  'no_class_found': '目前無任何班級',
  'file': '檔案',
  'download_template': '範本下載',
  'class_management': '班級管理',
  'class_information': '班級資料',
  'import_list_of_students': '匯入學生名單',
  'add_current_student': '從現有學生新增',
  'add_new': '單筆新增',
  'remove': '移除',
  'add': '新增',
  'at_least_4_characters': '需大於四位數',
  'name': '姓名',
  'student_id': '學號',
  'no_assignment_found': '目前無任何課程作業',
  'please_enter_course_name': '請輸入課程名稱...',
  'update': '更新課程',
  'add_course': '建立課程',
  'course_category': '課程類別',
  'daily_english': '生活類課程',
  'travel_shopping_english': '旅遊類課程',
  'course_level': '課程級別',
  'show_selected': '已選擇課程',
  'show_unselected': '未選擇課程',
  'course_has_not_been_saved_notice': '您並未儲存課程，關閉後資料將會遺失。',
  'please_name_this_course': '課程名稱不得為空白',
  'please_choose_course': '需選擇課程',
  'no_course_found': '目前無任何課程',
  'my_favorites': '我的最愛',
  'all_courses': '課程清單',
  'new_course': '新增課程',
  'course_assignment_deleting_confirm': '課程指派中，若刪除清單，學習紀錄會一併刪除。',
  'add_recourse': '新增資源',
  'keyword': '關鍵字',
  'search': '搜尋',
  'show_my_uploads_only': '只顯示我的檔案',
  // 'view': '查閱',
  'upload_files': '上傳檔案',
  'file_formats': '檔案上傳格式限制',
  'picture_format_required': '圖片：jpg, png (最大2M)',
  'video_format_required': '影片：mp4 (最大25M)',
  'audio_format_required': '聲音：mp3 (最大25M)',
  'online_resources_management': '資源管理',
  'please_choose_a_file': '請選擇檔案',
  'by_course': '課程紀錄列表',
  'by_assignment': '課程作業紀錄',
  'by_test': '考試成績列表',
  'no_result_found': '目前無資料',
  'score': '分數',
  'class_performance': '全班平均',
  'view_individual': '學生成績',
  'individual_student': '學生成績名單',
  'statistics': '個人成績',
  'assignment': '課程作業',
  'test_history': '考試歷程',
  'not_taken': '未考',
  'view_details': '查閱紀錄',
  'test_assigned': '指派考試',
  'score_management': '成績管理',
  'video': '影片',
  'transcript': '文字',
  'quiz': '測驗',
  'all': '全部',
  'times': '次數',
  'interactive': '互動',
  'type': '類型',
  'percentage': '比率',
  'category': '主題排行',
  'top_courses': '單元排行',
  'course_reports': '課程統計',
  'no_report_found': '目前無任何學習紀錄',
  'learning_record': '學習紀錄',
  'email': '電子信箱',
  'add_student': '新增學生',
  'import': '匯入名單',
  'export': '匯出名單',
  'no_student_found': '目前無任何學生',
  'student_management': '學生管理',
  'complete_list_of_students': '全部學生名單',
  'add_teacher': '新增老師',
  'no_teacher_found': '目前無任何老師',
  'teacher_management': '老師管理',
  'complete_list_of_teachers': '全部老師名單',
  'online_resources': '線上資源',
  'message': '訊息',
  'history': '歷史紀錄',
  'learning_record_mgr': '成績管理',
  'jp_course': '日文課程',
  'live_AR': 'LiveAR',
  'live_VR': 'LiveVR',
  'live_Culture': 'LiveCulture',
  'tour_taiwan': '遊臺灣學英文',
  'start_course': '開始上課',
  'using_record': '觀看使用紀錄',
  'download_instructions': '下載使用說明',
  'culture_function_menu': 'Live Culture 功能清單',
  'select_unit': '請從下方選擇任一個單元',
  'choose_the_course': '請選擇課程類別',
  'click_icon_t': '請點選左上角的',
  'click_icon_b': ',選擇你的學習課程。',
  'add_or_select': '新增或選擇清單',
  'class_list': '班級列表',
  'add_or_delete_class': '輸入班級資訊',
  'complete': '完成',
  'established_date': '建立時間',
  'student': '共 {count} 位學生',
  'class_info': '班級資訊',
  'add_single_student': '新增單筆學生',
  'batch_add_students': 'EXCEL 批次匯入學生',
  'add_a_class': '點我開始建立班級',
  'students_list': '學生清單',
  'selected_students': '已選學生',
  'enter_class_name': '請輸入班級名稱…',
  'edit_class_list': '修改班級名單',
  'please_enter_account_required': '請輸入帳號…(必填)',
  'please_enter_password_required': '請輸入密碼…(必填)',
  'please_enter_name_required': '請輸入姓名…(必填)',
  'please_enter_student_ID': '請輸入學號…',
  'please_enter_account_rule': '6個以上英數字元 + @ + 單位英文縮寫。',
  'sample_account': '範例：live199@twes',
  'please_enter_password_rule': '密碼至少6個英數字元',
  'please_enter_students_full_name': '請填寫真實姓名',
  'upload_the_excel_file': '上傳excel檔案',
  'download_sample_excel_file': '下載範例檔案',
  'click_to_select_file_upload': '點擊選擇要上傳的附件(請從您的電腦裡選擇要上傳的檔案)',
  'once_download': '一次只能上傳一個檔案',
  'upload_progress': '上傳進度',
  'select_topic': '請從下方選擇任一個主題',
  'lessons': '課程單元',
  'teachers_resources': '教用資源',
  'course_list': '課程清單',
  'start_a_course': '開始課程',
  'picture_dictionary': '圖解單字',
  'select_resources_download': '請從下方選擇想下載的教材',
  'web_record': 'Web紀錄',
  'app_record': 'App紀錄',
  'using_records': '紀錄',
  'start_new_course': '上課',
  'web_study_time': 'Web學習時間',
  'app_study_time': 'App學習時間',
  'web_schedule': 'Web進度',
  'app_schedule': 'App進度',
  'coins': '金幣數',
  'AR_unlocked': 'AR解鎖數',
  'missions_completed': '任務完成數',
  'course_name': '課程名稱',
  'unit_theme': '單元主題',
  'study_time': '學習時間',
  'views': '觀看次數',
  'oral_practice': '口說練習',
  // 'view': '觀看進度',
  'click_below_detailed': '請點選下列按紐並選擇觀看WEB或APP的詳細課程紀錄',
  'learning_contents': '課程內容',
  'last_update_time': '最新更新時間',
  'play': '播放',
  'download': '下載',
  'VR_function_list': 'Live VR Classroom 功能清單',
  'vocabulary_mission': '單字任務',
  'saved_successfully': '儲存成功',
  'added_vocabulary': '已新增單字',
  'select them_to_column': '請選擇7個單字並加入至右邊欄位',
  'scene': '情境',
  'character': '對象',
  'chance': '機會',
  'standard_score': '標準',
  'display': '顯示',
  'function': '功能',
  'mistake': '錯誤降分',
  'conversation_edit': '編輯內容',
  'selected_character': '選擇腳色',
  'dialogue': '句子',
  'save': '儲存',
  'date': '日期',
  'result': '結果',
  'speech_image': '語音辨識圖',
  'words_found': '找到數量',
  'general_list': '總表',
  'story_mode': '劇情模式',
  'vocabulary_mode': '單字模式',
  'conversation_mode': '對話模式',
  'usage_time': '使用時間',
  'total_usage_time': '使用總時間',
  'selected': '勾選',
  'all_selected': '全選',
  'valid_time': '序號有效時間',
  'generate_serial': '產生序號',
  'reminder': '友善提醒',
  'serial_number_rule': '您將產生一組僅提供本帳號使用的序號',
  'valid_until': '有效時間',
  'your_serial_number': '您的序號為',
  'export_file': '匯出報表',
  'fail': '失敗',
  'pass': '成功',
  'success_serial_number': '序號已產生',
  'input_name': '請輸入名稱',
  'symbols_rules': '建立課程內容時，請使用英文字母(a-z)和半行符號(「 , 」「 . 」「 ; 」「 ! 」「 ? 」 )',
  'save_editing_the_script': '請先儲存後再編輯對話，謝謝',
  'added_mission': '已新增對話任務',
  'customer_support': '客戶服務'
}



// WEBPACK FOOTER //
// ./src/locales/zh_tw.js